import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

export const Container = styled.div<{
    isUserMessage?: boolean;
}>(
    ({ isUserMessage }) => css`
        display: flex;
        justify-content: ${isUserMessage ? 'flex-end' : 'flex-start'};
    `,
);

export const MessageWrapper = styled.div<{
    avatarShown?: boolean;
    isUserMessage?: boolean;
}>(
    ({ avatarShown, isUserMessage }) => css`
        max-width: 555px;
        padding: 12px 16px;
        word-break: break-word;

        ${isUserMessage ? UserMessage : WatsonMessage};
        ${avatarShown &&
        !isUserMessage &&
        css`
            margin-left: 46px;
        `};
    `,
);

export const Message = styled(Typography.TextBody_16_24)<{
    isUserMessage?: boolean;
}>(
    ({ isUserMessage, theme: { palette } }) => css`
        color: ${isUserMessage ? palette.neutral.white : palette.text.primary};
    `,
);

const WatsonMessage = css(
    ({ theme: { palette, radius } }) => css`
        background: ${palette.neutral.gray};
        border-radius: ${`0 ${radius['8']}px ${radius['8']}px ${radius['8']}px`};
        color: ${palette.text.primary};
    `,
);

const UserMessage = css(
    ({ theme: { palette, radius } }) => css`
        background: ${palette.tertiary.default};
        border-radius: ${`${radius['8']}px 0 ${radius['8']}px ${radius['8']}px`};
        color: ${palette.neutral.white};
    `,
);
